import {
  EqualityFn,
  TypedUseSelectorHook,
  useDispatch,
  useSelector,
  useStore,
} from "react-redux";
import store, { RootState } from ".";
import isEqual from "lodash/isEqual";

export type AppDispatch = typeof store.dispatch;
export const useAppDispatch = () => useDispatch<AppDispatch>();

export const useAppSelector: TypedUseSelectorHook<RootState> = <TSelected>(
  selector: (state: RootState) => TSelected,
  equalityFn?: EqualityFn<TSelected>
): TSelected => useSelector<RootState, TSelected>(selector, isEqual);
export const useAppStore = () => useStore<RootState>();
